import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { HeptagonPattern } from "@/components/Logo";

export const NewsletterForm = ({ source = "footer", compact = false, onSuccess }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email, source });
      setCode(data.discount_code);
      localStorage.setItem("757_subscribed", "1");
      toast.success(data.message);
      onSuccess?.(data);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  if (code) {
    return (
      <div data-testid="newsletter-success" className="border border-[#0FB5A3]/40 px-4 py-3">
        <p className="text-xs text-white/60 uppercase tracking-[0.2em]">Your welcome code</p>
        <p className="text-xl font-display text-[#0FB5A3] mt-1 tracking-widest">{code}</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className={`flex ${compact ? "" : "max-w-md mx-auto"}`}>
      <input
        type="email"
        required
        data-testid={`newsletter-email-input-${source}`}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Email address"
        className="flex-1 bg-transparent border-b border-white/20 focus:border-[#0FB5A3] outline-none py-3 text-sm text-white placeholder:text-white/30 transition-colors"
      />
      <button
        type="submit"
        disabled={loading}
        data-testid={`newsletter-submit-btn-${source}`}
        aria-label="Subscribe"
        className="px-4 text-[#0FB5A3] hover:text-white transition-colors disabled:opacity-40"
      >
        <ArrowRight size={18} />
      </button>
    </form>
  );
};

export const NewsletterSection = ({
  label = "The Inner Circle",
  title = "Become Part Of The Legacy",
  copy = "Early access, exclusive drops, and member-only releases. Join the inner circle — plus 10% off your first order.",
}) => (
  <section className="relative py-28 border-t border-white/10 overflow-hidden">
    <HeptagonPattern opacity={0.05} />
    <div className="relative max-w-2xl mx-auto px-5 text-center">
      <p className="label-757 mb-4">{label}</p>
      <h2 className="font-display text-3xl sm:text-4xl font-semibold text-white tracking-tight mb-4">
        {title}
      </h2>
      <p className="text-sm text-white/50 mb-10 leading-relaxed">{copy}</p>
      <NewsletterForm source="homepage" />
    </div>
  </section>
);
